<template>
  <div>
    <el-row>
      <el-table :data="list" empty-text="No record!" height="350px" border stripe>
        <el-table-column align="center">
          <template slot-scope="scope">
              <el-image style="height:40px;width:40rpx;" fit="scale-down" :src="scope.row.img"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="ID">
            <template slot-scope="scope">
                {{scope.row.crafite_uuid.substring(2)}}
            </template>
        </el-table-column>
        <el-table-column prop="bind_time" label="Bind Time"></el-table-column>
      </el-table>
    </el-row>
    <!--<el-row>
      <el-col align="right">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total">
        </el-pagination>
      </el-col>
    </el-row>-->
    <el-row align="right">
      <el-col align="right">
      <el-button size="small" @click="$emit('close')">back</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'DeviceCrafite',
    props: {
      chooseItem: Object,
      close: Function
    },
    data () {
      return {
        list: []
      }
    },
    created () {
      this.getData()
    },
    methods: {
      getData () {
        let loading = this.$util.loading()
        this.$api.rootV1.post('/web/craftie/getbydevice', {device_id: this.chooseItem.device_id},
          (res) => {
            if (res.data.length !== 0) {
              this.list = res.data
            }
            loading.close()
          }, () => {
            loading.close()
          })
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/device/DevicesCrafite.vue